/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        /**
         * Main nav menu toggle
         */
        $('.menu-toggle').click(function(e){
          e.preventDefault();

          $('.banner').toggleClass('menu-open');
        });

        /**
         * Header search form reveal
         */
        $('.js-search-trigger').click(function() {
          $('.banner').toggleClass('search-open');
          if ( $('.banner.search-open').length > 0 ) {
            $('.banner .search-field').focus();
          }
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        /**
         * Flexslider
         */
        // store the slider in a local variable
        var $window = $(window),
            myflexslider,
            numSlides;

        // tiny helper function to add breakpoints
        function getGridSize() {
          return (window.innerWidth < 480) ? 1 :
                 (window.innerWidth < 768) ? 2 :
                 (window.innerWidth < 980) ? 3 : 4;
        }

        $window.load(function() {
          myflexslider = $('.flexslider').html();
          myflexslider = '<div class="flexslider">'+myflexslider+'</div>';
          numSlides = getGridSize();

          $('.flexslider').flexslider({
            animation: "slide",
            animationLoop: true,
            itemWidth: 211,
            itemMargin: 10,
            minItems: numSlides,
            maxItems: numSlides,
            controlNav: false
          });
        });

        // check grid size on resize event
        var reinitslider = _.debounce(function() {
          newNumSlides = getGridSize();

          // only reinit if the number of slides per page has changed
          if ( numSlides !== newNumSlides ) {
            numSlides = newNumSlides;
            $('.flexslider').remove();
            $('.slider-wrap').append(myflexslider);

            $('.flexslider').flexslider({
              animation: "slide",
              animationLoop: true,
              itemWidth: 211,
              itemMargin: 10,
              minItems: numSlides,
              maxItems: numSlides,
              controlNav: false
            });
          }
        },250);

        $window.resize(reinitslider);
        /** End Flexslider **/

        /**
         * Intro drawer
         */
        $('.js-intro-trigger').click(function(){
          $('.intro').toggleClass('open');
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
